import Vue from "vue";
import {post, qs} from "@/tools/http";

export default {
    namespaced: true,
    state: () => ({}),
    actions: {
        async getAddress({state}, {query, url}) {
            let res = await post(
                'dadata',
                url,
                qs({ query, type: 'address'}),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            );
            return res ? res.suggestions : [];
        },
    },
    getters: {},
};